import { useEffect } from 'react';

export const beforeUnloadHandler = function (event) {
  event.preventDefault();
  event.returnValue = '';
};

export const useBeforeUnload = (shouldShowPrompt) => {
  useEffect(() => {
    if (!shouldShowPrompt) {
      window.onbeforeunload = null;
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    } else {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    }

    return () => {
      window.onbeforeunload = null;
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    };
  }, [shouldShowPrompt]);
};
